import { render } from "./ChatBotSmoochM3.vue.ts?vue&type=template&id=6576864e&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochM3.vue?vue&type=template&id=6576864e&ts=true"
import script from "./ChatBotSmoochM3.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochM3.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatBotSmoochM3.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochM3.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/chatbot/ChatBotSmoochM3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6576864e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6576864e', __exports__)) {
    api.reload('6576864e', __exports__)
  }
  
  module.hot.accept("./ChatBotSmoochM3.vue.ts?vue&type=template&id=6576864e&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochM3.vue?vue&type=template&id=6576864e&ts=true", () => {
    api.rerender('6576864e', render)
  })

}


export default __exports__